// extracted by mini-css-extract-plugin
export default {"video-section":"video-view_video-section__NuvfX","inner-card":"video-view_inner-card__087t1","iframe":"video-view_iframe__TGPvC","joinUs-button":"video-view_joinUs-button__xKZsa"};